import React from 'react';
import { NavLink } from 'react-router-dom';
import DefaultLayout from '../../layouts/default';
import IncidentManagementHeader from './components/IncidentManagementHeader';
import IncidentTableComponent from './components/IncidentTableComponent';

function IncidentLogPage() {
  return (
    <DefaultLayout>
      <IncidentManagementHeader />
      <IncidentTableComponent />
    </DefaultLayout>
  );
}

export default IncidentLogPage;
